/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pre-assessment.reducer';

export const PreAssessmentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const preAssessmentEntity = useAppSelector(state => state.preAssessment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="preAssessmentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.preAssessment.detail.title">PreAssessment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.preAssessment.id">Id</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.id}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.preAssessment.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.preAssessment.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.preAssessment.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.preAssessment.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.preAssessment.active">Active</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="physicalActivity">
              <Translate contentKey="tinyMedicRestApp.preAssessment.physicalActivity">Physical Activity</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.physicalActivity}</dd>
          <dt>
            <span id="habbits">
              <Translate contentKey="tinyMedicRestApp.preAssessment.habbits">Habbits</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.habbits}</dd>
          <dt>
            <span id="habbitDetails">
              <Translate contentKey="tinyMedicRestApp.preAssessment.habbitDetails">Habbit Details</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.habbitDetails}</dd>
          <dt>
            <span id="sexualAbuse">
              <Translate contentKey="tinyMedicRestApp.preAssessment.sexualAbuse">Sexual Abuse</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.sexualAbuse ? 'true' : 'false'}</dd>
          <dt>
            <span id="sexualAbuseDetails">
              <Translate contentKey="tinyMedicRestApp.preAssessment.sexualAbuseDetails">Sexual Abuse Details</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.sexualAbuseDetails}</dd>
          <dt>
            <span id="exposureToPets">
              <Translate contentKey="tinyMedicRestApp.preAssessment.exposureToPets">Exposure To Pets</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.exposureToPets ? 'true' : 'false'}</dd>
          <dt>
            <span id="exposureToPetsDetails">
              <Translate contentKey="tinyMedicRestApp.preAssessment.exposureToPetsDetails">Exposure To Pets Details</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.exposureToPetsDetails}</dd>
          <dt>
            <span id="nutritionType">
              <Translate contentKey="tinyMedicRestApp.preAssessment.nutritionType">Nutrition Type</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.nutritionType}</dd>
          <dt>
            <span id="pastSurgicalHistory">
              <Translate contentKey="tinyMedicRestApp.preAssessment.pastSurgicalHistory">Past Surgical History</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.pastSurgicalHistory}</dd>
          <dt>
            <span id="systemicExamination">
              <Translate contentKey="tinyMedicRestApp.preAssessment.systemicExamination">Systemic Examination</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.systemicExamination}</dd>
          <dt>
            <span id="cardiovascularSystem">
              <Translate contentKey="tinyMedicRestApp.preAssessment.cardiovascularSystem">Cardiovascular System</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.cardiovascularSystem}</dd>
          <dt>
            <span id="respiratorySystem">
              <Translate contentKey="tinyMedicRestApp.preAssessment.respiratorySystem">Respiratory System</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.respiratorySystem}</dd>
          <dt>
            <span id="centralNervousSystem">
              <Translate contentKey="tinyMedicRestApp.preAssessment.centralNervousSystem">Central Nervous System</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.centralNervousSystem}</dd>
          <dt>
            <span id="abdomen">
              <Translate contentKey="tinyMedicRestApp.preAssessment.abdomen">Abdomen</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.abdomen}</dd>
          <dt>
            <span id="genitalNRectum">
              <Translate contentKey="tinyMedicRestApp.preAssessment.genitalNRectum">Genital N Rectum</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.genitalNRectum}</dd>
          <dt>
            <span id="skin">
              <Translate contentKey="tinyMedicRestApp.preAssessment.skin">Skin</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.skin}</dd>
          <dt>
            <span id="pulse">
              <Translate contentKey="tinyMedicRestApp.preAssessment.pulse">Pulse</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.pulse}</dd>
          <dt>
            <span id="extremities">
              <Translate contentKey="tinyMedicRestApp.preAssessment.extremities">Extremities</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.extremities}</dd>
          <dt>
            <span id="back">
              <Translate contentKey="tinyMedicRestApp.preAssessment.back">Back</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.back}</dd>
          <dt>
            <span id="uncommonSymptoms">
              <Translate contentKey="tinyMedicRestApp.preAssessment.uncommonSymptoms">Uncommon Symptoms</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.uncommonSymptoms}</dd>
          <dt>
            <span id="weightChanges">
              <Translate contentKey="tinyMedicRestApp.preAssessment.weightChanges">Weight Changes</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.weightChanges}</dd>
          <dt>
            <span id="fever">
              <Translate contentKey="tinyMedicRestApp.preAssessment.fever">Fever</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.fever}</dd>
          <dt>
            <span id="ageOfLastChild">
              <Translate contentKey="tinyMedicRestApp.preAssessment.ageOfLastChild">Age Of Last Child</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.ageOfLastChild}</dd>
          <dt>
            <span id="obstetricPara">
              <Translate contentKey="tinyMedicRestApp.preAssessment.obstetricPara">Obstetric Para</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.obstetricPara}</dd>
          <dt>
            <span id="obstetricGravida">
              <Translate contentKey="tinyMedicRestApp.preAssessment.obstetricGravida">Obstetric Gravida</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.obstetricGravida}</dd>
          <dt>
            <span id="abortions">
              <Translate contentKey="tinyMedicRestApp.preAssessment.abortions">Abortions</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.abortions}</dd>
          <dt>
            <span id="sourceOfHistory">
              <Translate contentKey="tinyMedicRestApp.preAssessment.sourceOfHistory">Source Of History</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.sourceOfHistory}</dd>
          <dt>
            <span id="chiefComplaints">
              <Translate contentKey="tinyMedicRestApp.preAssessment.chiefComplaints">Chief Complaints</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.chiefComplaints}</dd>
          <dt>
            <span id="historyOfPresentIllness">
              <Translate contentKey="tinyMedicRestApp.preAssessment.historyOfPresentIllness">History Of Present Illness</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.historyOfPresentIllness}</dd>
          <dt>
            <span id="medicalHistory">
              <Translate contentKey="tinyMedicRestApp.preAssessment.medicalHistory">Medical History</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.medicalHistory}</dd>
          <dt>
            <span id="familyHistory">
              <Translate contentKey="tinyMedicRestApp.preAssessment.familyHistory">Family History</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.familyHistory}</dd>
          <dt>
            <span id="admissiondiagnosis">
              <Translate contentKey="tinyMedicRestApp.preAssessment.admissiondiagnosis">Admissiondiagnosis</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.admissiondiagnosis}</dd>
          <dt>
            <span id="historyOfImmunization">
              <Translate contentKey="tinyMedicRestApp.preAssessment.historyOfImmunization">History Of Immunization</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.historyOfImmunization}</dd>
          <dt>
            <span id="medicineReviewed">
              <Translate contentKey="tinyMedicRestApp.preAssessment.medicineReviewed">Medicine Reviewed</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.medicineReviewed ? 'true' : 'false'}</dd>
          <dt>
            <span id="assessmentType">
              <Translate contentKey="tinyMedicRestApp.preAssessment.assessmentType">Assessment Type</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.assessmentType}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="tinyMedicRestApp.preAssessment.code">Code</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.code}</dd>
          <dt>
            <span id="addedById">
              <Translate contentKey="tinyMedicRestApp.preAssessment.addedById">Added By Id</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.addedById}</dd>
          <dt>
            <span id="modifiedById">
              <Translate contentKey="tinyMedicRestApp.preAssessment.modifiedById">Modified By Id</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.modifiedById}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.preAssessment.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.addedByType}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.preAssessment.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.modifiedByType}</dd>
          <dt>
            <span id="consciousness">
              <Translate contentKey="tinyMedicRestApp.preAssessment.consciousness">Consciousness</Translate>
            </span>
          </dt>
          <dd>{preAssessmentEntity.consciousness}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preAssessment.admission">Admission</Translate>
          </dt>
          <dd>{preAssessmentEntity.admission ? preAssessmentEntity.admission.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preAssessment.gynicHistory">Gynic History</Translate>
          </dt>
          <dd>{preAssessmentEntity.gynicHistory ? preAssessmentEntity.gynicHistory.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preAssessment.obstetricEvent">Obstetric Event</Translate>
          </dt>
          <dd>{preAssessmentEntity.obstetricEvent ? preAssessmentEntity.obstetricEvent.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pre-assessment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pre-assessment/${preAssessmentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PreAssessmentDetail;
